import React from 'react';
import colors from '@app/constants/colors';
import styled from 'styled-components';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from '@app/components/index';
import RouterConstants from '@app/constants/router';

const SignUpConfirmFail = ({ error }) => (
  <React.Fragment>
    <Header><FormattedMessage id="signUp.confirmation.validationFailed" /></Header>
    {
      error && (
        <Error>
          <FormattedMessage id={`signUp.confirmation.errors.${get(error, 'code')}`} />
        </Error>
      )
    }
    <Message1><FormattedMessage id="signUp.confirmation.notActivated" /></Message1>
    <Message2><FormattedMessage id="signUp.confirmation.tryAgain" /></Message2>
    <Button
      wide
      bordered
      labelId="buttons.signUp"
      textColor={colors.BUTTERFLY_BUSH}
      backgroundColor={colors.SANDWISP}
      path={RouterConstants.SUBSCRIBE}
    />
  </React.Fragment>
);

export default SignUpConfirmFail;

SignUpConfirmFail.propTypes = {
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

SignUpConfirmFail.defaultProps = {
  error: null,
};

const Header = styled.h1`
  text-transform: uppercase;
`;

const Error = styled.h3`
  color: ${colors.ERROR_COLOR};
`;

const Message1 = styled.p`
  margin-bottom: 10px;
`;

const Message2 = styled.p`
  margin: 0 0 60px;
  @media (max-width: 979px) {
    margin-bottom: 30px;
  }  
`;
